import React, { useState } from "react";
import "./index.scss";
import resume from "../../images/resume.png";
import resumeEn from "../../images/resume-en.png";

const Cv = function() {
  const options = ["Español", "Ingles"];
  const [selected, setSelected] = useState(options[0]);

  return (
    <div className="cv">
      <div className="cv__title">
        <span>Curriculum Vitae</span>
        <div className="cv__custom-select">
          <select onChange={e => setSelected(e.target.value)}>
            {options.map((opt, idx) => (
              <option key={idx} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
        <a
          href={
            selected === "Ingles"
              ? "./resume-zetagh-en.pdf"
              : "./resume-zetagh.pdf"
          }
          download
        >
          {selected === "Ingles" ? "Download" : "Descargar"}
        </a>
      </div>
      <div className="cv__document">
        <img src={selected === "Ingles" ? resumeEn : resume} alt="resume" />
      </div>
    </div>
  );
};

export default Cv;
